import { useRef, useEffect } from "react";

const IndeterminateCheckbox = ({ indeterminate, className = "", ...rest }) => {
  const ref = useRef();

  useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <div className="d-flex align-items-center">
      <input
        type="checkbox"
        ref={ref}
        className={className + " cursor-pointer "}
        {...rest}
      />
    </div>
  );
};

export default IndeterminateCheckbox;
